"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { Control, Controller, FieldError } from "react-hook-form";
import { RiCloseLine } from "react-icons/ri";
import Button from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { DynamicSelectItem, SearchSelect, SearchSelectContent, SearchSelectItem, SearchSelectTrigger, SearchSelectValue } from "@/components/ui/select";
import { formatToHumanReadable } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { patientQueryOptions } from "@/api/provider/user/patient/patient-query";
interface LeadSourceSelectProps {
  name: string;
  control: Control<any>;
  error?: FieldError;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
}
export function LeadSourceSelect(t0) {
  const $ = _c(26);
  const {
    name,
    control,
    error,
    label: t1,
    placeholder: t2,
    required: t3,
    className: t4
  } = t0;
  const label = t1 === undefined ? "Lead Source" : t1;
  const placeholder = t2 === undefined ? "Select or add lead source" : t2;
  const required = t3 === undefined ? false : t3;
  const className = t4 === undefined ? "" : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = patientQueryOptions.leadSources();
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const {
    data: t6,
    isLoading
  } = useQuery(t5);
  let t7;
  if ($[1] !== t6) {
    t7 = t6 === undefined ? [] : t6;
    $[1] = t6;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const leadSources = t7;
  let t8;
  if ($[3] !== className) {
    t8 = cx("space-y-1", className);
    $[3] = className;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== label || $[6] !== name || $[7] !== required) {
    t9 = label && <Label htmlFor={name} mandatory={required}>{label}</Label>;
    $[5] = label;
    $[6] = name;
    $[7] = required;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== label || $[10] !== required) {
    t10 = required ? {
      required: `${label} is required`
    } : undefined;
    $[9] = label;
    $[10] = required;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== error || $[13] !== isLoading || $[14] !== leadSources || $[15] !== placeholder) {
    t11 = t12 => {
      const {
        field
      } = t12;
      return <div className="relative"><SearchSelect value={field.value || ""} onValueChange={field.onChange}><SearchSelectTrigger hasError={!!error} errorMessage={error?.message}><SearchSelectValue placeholder={placeholder} formatValue={formatToHumanReadable} /></SearchSelectTrigger><SearchSelectContent searchPlaceholder="Search lead source..." emptyMessage={isLoading ? "Loading..." : "No lead source found."}>{leadSources.map(_temp)}<DynamicSelectItem label="Add new lead source" addPlaceholder="Enter new lead source..." initialValue={field.value} onAddOption={value => {
              const normalizedValue = value.trim().toUpperCase();
              const existingSource = leadSources.find(source_0 => source_0.toUpperCase() === normalizedValue);
              if (existingSource) {
                field.onChange(existingSource);
              } else {
                field.onChange(normalizedValue);
              }
            }} /></SearchSelectContent></SearchSelect>{field.value && <Button type="button" variant="ghost" size="sm" className="absolute right-8 top-1/2 h-6 w-6 -translate-y-1/2 p-0 hover:bg-hover" onClick={() => field.onChange("")} icon={<RiCloseLine className="h-3 w-3" />} />}</div>;
    };
    $[12] = error;
    $[13] = isLoading;
    $[14] = leadSources;
    $[15] = placeholder;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== control || $[18] !== name || $[19] !== t10 || $[20] !== t11) {
    t12 = <Controller name={name} control={control} rules={t10} render={t11} />;
    $[17] = control;
    $[18] = name;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t8 || $[24] !== t9) {
    t13 = <div className={t8}>{t9}{t12}</div>;
    $[22] = t12;
    $[23] = t8;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
function _temp(source) {
  return <SearchSelectItem key={source} value={source}>{formatToHumanReadable(source)}</SearchSelectItem>;
}